import {createTheme, ThemeProvider} from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import {AdapterMoment} from "@mui/x-date-pickers/AdapterMoment";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {useState} from "react";


export default function MuiDatepicker(props) {
    const theme = createTheme({
        components: {
            MuiPickersBasePicker: {
                styleOverrides: {
                    pickerView: {
                        backgroundColor: "white"
                    }
                }
            }
        }
    });

    const [open, setOpen] = useState(false);

    return (
        <ThemeProvider theme={theme}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                    open={open}
                    onOpen={() => setOpen(true)}
                    onClose={() => setOpen(false)}
                    sx={{
                        width: "90%",
                        height: "70%",
                        "& .MuiInputBase-input": {
                            pt: "8.5px",
                            pb: "8.5px",
                            height: "50px"
                        },
                        "& .MuiInputLabel-formControl:not(.MuiInputLabel-shrink)": {
                            top: "-7px"
                        },
                        "& .MuiInputLabel-root": {
                            fontSize: "0.75rem" // Adjust the font size as per your requirement
                        }
                    }}
                    // slotProps={{
                    //   textField: {
                    //     onClick: () => setOpen(true),
                    //   },
                    // }}
                    {...props}
                    renderInput={(params) => (
                        <TextField
                            size="small"
                            {...params}
                            style={{
                                height: "0%",
                                width: "100%" // Adjust the width as per your requirement
                            }}
                            InputLabelProps={{
                                style: {
                                    fontSize: "0.95rem" // Adjust the font size as per your requirement
                                }
                            }}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    props.searchFunction();
                                }
                            }}
                            onClick={() => setOpen(true)} // Ensure the calendar opens on click
                        />
                    )}
                    className={`${props.className} custom-datepicker`}
                />
            </LocalizationProvider>
        </ThemeProvider>
    );
}